/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AdminUpdateUserReqVo,
  BatchUpdateCustomerServiceVo,
  ResetPasswordByEmailReqVo,
  ResetPasswordReqVo,
  ResponseAdminUpdateUserReqVo,
  ResponseBoolean,
  ResponseListUserSimpleDto,
  ResponseListUserVo,
  ResponseLong,
  ResponsePageDataUserPageResVo,
  ResponseString,
  ResponseUserAndBusinessLicenseInfoVo,
  ResponseUserLoginResVo,
  ResponseUserStatisticsInfoVo,
  UpdateUserReqVo,
  UserLoginReqVo,
  UserMobileLoginReqVo,
  UserPasswordReqVo,
  UserRegisterVo,
} from '../models/index';
import {
    AdminUpdateUserReqVoFromJSON,
    AdminUpdateUserReqVoToJSON,
    BatchUpdateCustomerServiceVoFromJSON,
    BatchUpdateCustomerServiceVoToJSON,
    ResetPasswordByEmailReqVoFromJSON,
    ResetPasswordByEmailReqVoToJSON,
    ResetPasswordReqVoFromJSON,
    ResetPasswordReqVoToJSON,
    ResponseAdminUpdateUserReqVoFromJSON,
    ResponseAdminUpdateUserReqVoToJSON,
    ResponseBooleanFromJSON,
    ResponseBooleanToJSON,
    ResponseListUserSimpleDtoFromJSON,
    ResponseListUserSimpleDtoToJSON,
    ResponseListUserVoFromJSON,
    ResponseListUserVoToJSON,
    ResponseLongFromJSON,
    ResponseLongToJSON,
    ResponsePageDataUserPageResVoFromJSON,
    ResponsePageDataUserPageResVoToJSON,
    ResponseStringFromJSON,
    ResponseStringToJSON,
    ResponseUserAndBusinessLicenseInfoVoFromJSON,
    ResponseUserAndBusinessLicenseInfoVoToJSON,
    ResponseUserLoginResVoFromJSON,
    ResponseUserLoginResVoToJSON,
    ResponseUserStatisticsInfoVoFromJSON,
    ResponseUserStatisticsInfoVoToJSON,
    UpdateUserReqVoFromJSON,
    UpdateUserReqVoToJSON,
    UserLoginReqVoFromJSON,
    UserLoginReqVoToJSON,
    UserMobileLoginReqVoFromJSON,
    UserMobileLoginReqVoToJSON,
    UserPasswordReqVoFromJSON,
    UserPasswordReqVoToJSON,
    UserRegisterVoFromJSON,
    UserRegisterVoToJSON,
} from '../models/index';

export interface UserCheckUserNameGetRequest {
    userName: string;
}

export interface UserCustomerServiceBatchPutRequest {
    batchUpdateCustomerServiceVo?: BatchUpdateCustomerServiceVo;
}

export interface UserGetUserByNameOrCodeGetRequest {
    userNameOrCode: string;
}

export interface UserGetUserIdByMobileGetRequest {
    mobileNumber: string;
}

export interface UserGetUserStatisticsInfoUserIdGetRequest {
    userId: number;
}

export interface UserIdAdminGetRequest {
    id: number;
}

export interface UserIdAdminUpdatePostRequest {
    id: number;
    adminUpdateUserReqVo?: AdminUpdateUserReqVo;
}

export interface UserIdCustomerServicePutRequest {
    id: number;
    customerServiceStaffId?: number;
}

export interface UserIdDeleteRequest {
    id: number;
}

export interface UserIdDisablePutRequest {
    id: number;
}

export interface UserIdEnablePutRequest {
    id: number;
}

export interface UserIdGetRequest {
    id: number;
}

export interface UserIdLogoutPutRequest {
    id: number;
}

export interface UserIdUpdatePostRequest {
    id: number;
    updateUserReqVo?: UpdateUserReqVo;
}

export interface UserLoginByMobilePostRequest {
    userMobileLoginReqVo?: UserMobileLoginReqVo;
}

export interface UserLoginPostRequest {
    userLoginReqVo?: UserLoginReqVo;
}

export interface UserPageGetRequest {
    currentPage?: number;
    pageSize?: number;
    gradeId?: number;
    account?: string;
    name?: string;
    code?: string;
    recommendUserName?: string;
    recommendCode?: string;
    mobileNo?: string;
    customServiceStaffId?: number;
    merchantName?: string;
    enables?: Array<number>;
    groupId?: number;
    sortField?: string;
    sortOrder?: string;
}

export interface UserPasswordIdPutRequest {
    id: number;
    userPasswordReqVo?: UserPasswordReqVo;
}

export interface UserPasswordPutRequest {
    userPasswordReqVo?: UserPasswordReqVo;
}

export interface UserRegisterPostRequest {
    userRegisterVo?: UserRegisterVo;
}

export interface UserResetPasswordByEmailPostRequest {
    resetPasswordByEmailReqVo?: ResetPasswordByEmailReqVo;
}

export interface UserResetPasswordPostRequest {
    resetPasswordReqVo?: ResetPasswordReqVo;
}

export interface UserSearchGetRequest {
    keyword: string;
}

export interface UserSendEmailVerificationCodeGetRequest {
    email?: string;
}

export interface UserSendLoginMobileVerificationCodeGetRequest {
    mobileNumber?: string;
}

export interface UserSendMobileVerificationCodeGetRequest {
    mobileNumber?: string;
}

export interface UserSendPasswordVerifyCodeGetRequest {
    userId: number;
}

export interface UserSendResetPasswordEmailVerificationCodeGetRequest {
    email?: string;
}

/**
 * 
 */
export class UserControllerApi extends runtime.BaseAPI {

    /**
     * 
     * 检查用户名是否存在
     */
    async userCheckUserNameGetRaw(requestParameters: UserCheckUserNameGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        if (requestParameters['userName'] == null) {
            throw new runtime.RequiredError(
                'userName',
                'Required parameter "userName" was null or undefined when calling userCheckUserNameGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userName'] != null) {
            queryParameters['userName'] = requestParameters['userName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/checkUserName`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * 
     * 检查用户名是否存在
     */
    async userCheckUserNameGet(requestParameters: UserCheckUserNameGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.userCheckUserNameGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 批量更新用户客服
     */
    async userCustomerServiceBatchPutRaw(requestParameters: UserCustomerServiceBatchPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/customerService/batch`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BatchUpdateCustomerServiceVoToJSON(requestParameters['batchUpdateCustomerServiceVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 批量更新用户客服
     */
    async userCustomerServiceBatchPut(requestParameters: UserCustomerServiceBatchPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.userCustomerServiceBatchPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 根据用户名或用户编码获取用户列表
     */
    async userGetUserByNameOrCodeGetRaw(requestParameters: UserGetUserByNameOrCodeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListUserVo>> {
        if (requestParameters['userNameOrCode'] == null) {
            throw new runtime.RequiredError(
                'userNameOrCode',
                'Required parameter "userNameOrCode" was null or undefined when calling userGetUserByNameOrCodeGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userNameOrCode'] != null) {
            queryParameters['userNameOrCode'] = requestParameters['userNameOrCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/getUserByNameOrCode`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListUserVoFromJSON(jsonValue));
    }

    /**
     * 
     * 根据用户名或用户编码获取用户列表
     */
    async userGetUserByNameOrCodeGet(requestParameters: UserGetUserByNameOrCodeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListUserVo> {
        const response = await this.userGetUserByNameOrCodeGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 校验手机号是否存在有效用户，存在返回用户ID
     */
    async userGetUserIdByMobileGetRaw(requestParameters: UserGetUserIdByMobileGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['mobileNumber'] == null) {
            throw new runtime.RequiredError(
                'mobileNumber',
                'Required parameter "mobileNumber" was null or undefined when calling userGetUserIdByMobileGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['mobileNumber'] != null) {
            queryParameters['mobileNumber'] = requestParameters['mobileNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/getUserIdByMobile`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 
     * 校验手机号是否存在有效用户，存在返回用户ID
     */
    async userGetUserIdByMobileGet(requestParameters: UserGetUserIdByMobileGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.userGetUserIdByMobileGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取用户的统计信息
     */
    async userGetUserStatisticsInfoUserIdGetRaw(requestParameters: UserGetUserStatisticsInfoUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUserStatisticsInfoVo>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling userGetUserStatisticsInfoUserIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/getUserStatisticsInfo/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUserStatisticsInfoVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取用户的统计信息
     */
    async userGetUserStatisticsInfoUserIdGet(requestParameters: UserGetUserStatisticsInfoUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUserStatisticsInfoVo> {
        const response = await this.userGetUserStatisticsInfoUserIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取用户信息 (管理端)
     */
    async userIdAdminGetRaw(requestParameters: UserIdAdminGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseAdminUpdateUserReqVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userIdAdminGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/{id}/admin`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseAdminUpdateUserReqVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取用户信息 (管理端)
     */
    async userIdAdminGet(requestParameters: UserIdAdminGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseAdminUpdateUserReqVo> {
        const response = await this.userIdAdminGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 修改用户信息 (管理端)
     */
    async userIdAdminUpdatePostRaw(requestParameters: UserIdAdminUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userIdAdminUpdatePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/{id}/admin/update`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminUpdateUserReqVoToJSON(requestParameters['adminUpdateUserReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 修改用户信息 (管理端)
     */
    async userIdAdminUpdatePost(requestParameters: UserIdAdminUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.userIdAdminUpdatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 更新用户客服
     */
    async userIdCustomerServicePutRaw(requestParameters: UserIdCustomerServicePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userIdCustomerServicePut().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['customerServiceStaffId'] != null) {
            queryParameters['CustomerServiceStaffId'] = requestParameters['customerServiceStaffId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/{id}/customerService`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 更新用户客服
     */
    async userIdCustomerServicePut(requestParameters: UserIdCustomerServicePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.userIdCustomerServicePutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 删除用户
     */
    async userIdDeleteRaw(requestParameters: UserIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 删除用户
     */
    async userIdDelete(requestParameters: UserIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.userIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 注销用户
     */
    async userIdDisablePutRaw(requestParameters: UserIdDisablePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userIdDisablePut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 注销用户
     */
    async userIdDisablePut(requestParameters: UserIdDisablePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.userIdDisablePutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 启用用户
     */
    async userIdEnablePutRaw(requestParameters: UserIdEnablePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userIdEnablePut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/{id}/enable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 启用用户
     */
    async userIdEnablePut(requestParameters: UserIdEnablePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.userIdEnablePutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取用户信息
     */
    async userIdGetRaw(requestParameters: UserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUserAndBusinessLicenseInfoVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUserAndBusinessLicenseInfoVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取用户信息
     */
    async userIdGet(requestParameters: UserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUserAndBusinessLicenseInfoVo> {
        const response = await this.userIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 用户退出
     */
    async userIdLogoutPutRaw(requestParameters: UserIdLogoutPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userIdLogoutPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/{id}/logout`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 用户退出
     */
    async userIdLogoutPut(requestParameters: UserIdLogoutPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.userIdLogoutPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 修改用户信息
     */
    async userIdUpdatePostRaw(requestParameters: UserIdUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userIdUpdatePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/{id}/update`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserReqVoToJSON(requestParameters['updateUserReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 修改用户信息
     */
    async userIdUpdatePost(requestParameters: UserIdUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.userIdUpdatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 手机号验证码登录
     */
    async userLoginByMobilePostRaw(requestParameters: UserLoginByMobilePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUserLoginResVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/loginByMobile`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserMobileLoginReqVoToJSON(requestParameters['userMobileLoginReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUserLoginResVoFromJSON(jsonValue));
    }

    /**
     * 
     * 手机号验证码登录
     */
    async userLoginByMobilePost(requestParameters: UserLoginByMobilePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUserLoginResVo> {
        const response = await this.userLoginByMobilePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 用户登录
     */
    async userLoginPostRaw(requestParameters: UserLoginPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUserLoginResVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/login`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserLoginReqVoToJSON(requestParameters['userLoginReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUserLoginResVoFromJSON(jsonValue));
    }

    /**
     * 
     * 用户登录
     */
    async userLoginPost(requestParameters: UserLoginPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUserLoginResVo> {
        const response = await this.userLoginPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取用户分页列表；支持列头排序（sortField=createTime 注册时间/lastLoginTime 最后登录时间，sortOrder=asc/desc 默认 desc），不传时默认按 id 升序
     */
    async userPageGetRaw(requestParameters: UserPageGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataUserPageResVo>> {
        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['gradeId'] != null) {
            queryParameters['gradeId'] = requestParameters['gradeId'];
        }

        if (requestParameters['account'] != null) {
            queryParameters['account'] = requestParameters['account'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['recommendUserName'] != null) {
            queryParameters['recommendUserName'] = requestParameters['recommendUserName'];
        }

        if (requestParameters['recommendCode'] != null) {
            queryParameters['recommendCode'] = requestParameters['recommendCode'];
        }

        if (requestParameters['mobileNo'] != null) {
            queryParameters['mobileNo'] = requestParameters['mobileNo'];
        }

        if (requestParameters['customServiceStaffId'] != null) {
            queryParameters['customServiceStaffId'] = requestParameters['customServiceStaffId'];
        }

        if (requestParameters['merchantName'] != null) {
            queryParameters['merchantName'] = requestParameters['merchantName'];
        }

        if (requestParameters['enables'] != null) {
            queryParameters['enables'] = requestParameters['enables'];
        }

        if (requestParameters['groupId'] != null) {
            queryParameters['groupId'] = requestParameters['groupId'];
        }

        if (requestParameters['sortField'] != null) {
            queryParameters['sortField'] = requestParameters['sortField'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/page`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataUserPageResVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取用户分页列表；支持列头排序（sortField=createTime 注册时间/lastLoginTime 最后登录时间，sortOrder=asc/desc 默认 desc），不传时默认按 id 升序
     */
    async userPageGet(requestParameters: UserPageGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataUserPageResVo> {
        const response = await this.userPageGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 用户·找回密码修改密码
     * 用户·找回密码修改密码
     */
    async userPasswordIdPutRaw(requestParameters: UserPasswordIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling userPasswordIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/password/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UserPasswordReqVoToJSON(requestParameters['userPasswordReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 用户·找回密码修改密码
     * 用户·找回密码修改密码
     */
    async userPasswordIdPut(requestParameters: UserPasswordIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.userPasswordIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 用户·修改密码
     * 用户·修改密码
     */
    async userPasswordPutRaw(requestParameters: UserPasswordPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/password`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UserPasswordReqVoToJSON(requestParameters['userPasswordReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 用户·修改密码
     * 用户·修改密码
     */
    async userPasswordPut(requestParameters: UserPasswordPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.userPasswordPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 用户注册
     */
    async userRegisterPostRaw(requestParameters: UserRegisterPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/register`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserRegisterVoToJSON(requestParameters['userRegisterVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 用户注册
     */
    async userRegisterPost(requestParameters: UserRegisterPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.userRegisterPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 确认邮箱验证码并把密码重置为123456
     */
    async userResetPasswordByEmailPostRaw(requestParameters: UserResetPasswordByEmailPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/resetPasswordByEmail`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResetPasswordByEmailReqVoToJSON(requestParameters['resetPasswordByEmailReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 确认邮箱验证码并把密码重置为123456
     */
    async userResetPasswordByEmailPost(requestParameters: UserResetPasswordByEmailPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.userResetPasswordByEmailPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 确认手机验证码并把密码重置为123456
     */
    async userResetPasswordPostRaw(requestParameters: UserResetPasswordPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/resetPassword`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResetPasswordReqVoToJSON(requestParameters['resetPasswordReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 确认手机验证码并把密码重置为123456
     */
    async userResetPasswordPost(requestParameters: UserResetPasswordPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.userResetPasswordPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 用户·关键字搜索会员 姓名、会员编号、登录账号OR搜索；去首尾空格，空关键字返回空数组。仅未删除且启用会员，最多20条，按ID倒序；id和gradeId以字符串返回。沿用全局登录鉴权，有效员工会话可调用；本接口无独立员工专属或细粒度权限门禁。资金检查创建任务须先选定会员再传userId
     * 用户·关键字搜索会员
     */
    async userSearchGetRaw(requestParameters: UserSearchGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListUserSimpleDto>> {
        if (requestParameters['keyword'] == null) {
            throw new runtime.RequiredError(
                'keyword',
                'Required parameter "keyword" was null or undefined when calling userSearchGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['keyword'] != null) {
            queryParameters['keyword'] = requestParameters['keyword'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListUserSimpleDtoFromJSON(jsonValue));
    }

    /**
     * 用户·关键字搜索会员 姓名、会员编号、登录账号OR搜索；去首尾空格，空关键字返回空数组。仅未删除且启用会员，最多20条，按ID倒序；id和gradeId以字符串返回。沿用全局登录鉴权，有效员工会话可调用；本接口无独立员工专属或细粒度权限门禁。资金检查创建任务须先选定会员再传userId
     * 用户·关键字搜索会员
     */
    async userSearchGet(requestParameters: UserSearchGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListUserSimpleDto> {
        const response = await this.userSearchGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 发送邮箱验证码
     */
    async userSendEmailVerificationCodeGetRaw(requestParameters: UserSendEmailVerificationCodeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        if (requestParameters['email'] != null) {
            queryParameters['email'] = requestParameters['email'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/sendEmailVerificationCode`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 发送邮箱验证码
     */
    async userSendEmailVerificationCodeGet(requestParameters: UserSendEmailVerificationCodeGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.userSendEmailVerificationCodeGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 发送短信登录验证码（仅已注册且启用的手机号可发，同手机号60秒内禁止重发）
     */
    async userSendLoginMobileVerificationCodeGetRaw(requestParameters: UserSendLoginMobileVerificationCodeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        if (requestParameters['mobileNumber'] != null) {
            queryParameters['mobileNumber'] = requestParameters['mobileNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/sendLoginMobileVerificationCode`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 发送短信登录验证码（仅已注册且启用的手机号可发，同手机号60秒内禁止重发）
     */
    async userSendLoginMobileVerificationCodeGet(requestParameters: UserSendLoginMobileVerificationCodeGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.userSendLoginMobileVerificationCodeGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 发送手机验证码
     */
    async userSendMobileVerificationCodeGetRaw(requestParameters: UserSendMobileVerificationCodeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        if (requestParameters['mobileNumber'] != null) {
            queryParameters['mobileNumber'] = requestParameters['mobileNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/sendMobileVerificationCode`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 发送手机验证码
     */
    async userSendMobileVerificationCodeGet(requestParameters: UserSendMobileVerificationCodeGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.userSendMobileVerificationCodeGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 发送修改密码验证码
     */
    async userSendPasswordVerifyCodeGetRaw(requestParameters: UserSendPasswordVerifyCodeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling userSendPasswordVerifyCodeGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/sendPasswordVerifyCode`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 发送修改密码验证码
     */
    async userSendPasswordVerifyCodeGet(requestParameters: UserSendPasswordVerifyCodeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.userSendPasswordVerifyCodeGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 发送找回密码邮箱验证码，返回用户ID
     */
    async userSendResetPasswordEmailVerificationCodeGetRaw(requestParameters: UserSendResetPasswordEmailVerificationCodeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        const queryParameters: any = {};

        if (requestParameters['email'] != null) {
            queryParameters['email'] = requestParameters['email'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/sendResetPasswordEmailVerificationCode`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 
     * 发送找回密码邮箱验证码，返回用户ID
     */
    async userSendResetPasswordEmailVerificationCodeGet(requestParameters: UserSendResetPasswordEmailVerificationCodeGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.userSendResetPasswordEmailVerificationCodeGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
